export const neighborhoods = ['L.A.', 'Pico-Union', 'Van Nuys', 'South L.A.', 'Westlake', 'the Valley'];
